import { z } from 'zod'

/** Snackbar variant available. */
export const VariantSnackbar = z.enum(['info', 'error', 'success'])
export type VariantSnackbar = z.infer<typeof VariantSnackbar>
